// extracted by mini-css-extract-plugin
export var cardCaption = "lMlldawaaIzeakAQZiVF";
export var cardImage = "rw3oVCuZipA5y1YEln4W";
export var cardIssuerLabel = "iRTgUPGbjmlWdrY2s4bt";
export var cardLabel = "bzZa4inR5SZLTa6P1ZGM";
export var cards = "qZoBexk5zwAFOSa6Xhrw";
export var imageSkeleton = "k7yh_wv1sNhH4N2ICZqZ";
export var issuerSkeleton = "epWR0pqoxPptWH2y3mQg";
export var labelSkeleton = "YTmf_yGaGUwzuiRIEyAh";
export var skeletonItem = "vlq282k32ZeHa3wKqjJJ";